var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C5.895 2 5 2.895 5 4V20C5 21.105 5.895 22 7 22H17C18.105 22 19 21.105 19 20V4C19 2.895 18.105 2 17 2H7ZM7 4H17V13H7V4ZM12 14C12.552 14 13 14.448 13 15C13 15.552 12.552 16 12 16C11.448 16 11 15.552 11 15C11 14.448 11.448 14 12 14ZM8 17H10V18H7C7 17.448 7.448 17 8 17ZM11 17H13V18H11V17ZM14 17H16C16.552 17 17 17.448 17 18H14V17ZM7 19H10V20H8C7.448 20 7 19.552 7 19ZM11 19H13V20H11V19ZM14 19H17C17 19.552 16.552 20 16 20H14V19Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/Cell.0309af0c0a6094b95ce30602d4ec93a9.svg";
export { ForwardRef as ReactComponent };